<script setup>
  import { useSystem } from "../../store/system"
  import {onMounted, reactive, ref} from "vue";
  import {useRoute, useRouter} from "vue-router";
  import {ElMessage} from "element-plus";

  const router = useRouter()
  const route = useRoute()
  if (route.query.btc) {
    //记录用户来源的渠道 从哪里跳转过来的
    window.localStorage.setItem('mine_src', route.query.btc)
  }

  const systemStore = useSystem()
  systemStore.systemInfoApi()
  const website = systemStore.getWebsite
  // console.log(123456, route.query.invite_code)
  const formData = reactive({
    email: '',
    password: '',
    inviter: route.query.invite_code? route.query.invite_code : '',
    code: '',
    btc: '',
  })

  const submitLoading = ref(false)
  const signUpSubmit = () => {
    if (!formData.email) {
      ElMessage({
        duration: 1500,
        message: "Email cannot be empty",
        type: 'error',
        onClose: () => {}
      })
      return
    }
    if (!formData.password) {
      ElMessage({
        duration: 1500,
        message: "Password cannot be empty",
        type: 'error',
        onClose: () => {}
      })
      return
    }
    // if (!formData.inviter) {
    //   ElMessage({
    //     duration: 1500,
    //     message: "Invitation code cannot be empty",
    //     type: 'error',
    //     onClose: () => {}
    //   })
    //   return
    // }
    submitLoading.value = true
    formData.btc = window.localStorage.getItem('mine_src')
    systemStore.emailRegisterApi(formData, router)
    setTimeout(() => {
      submitLoading.value = false
      window.localStorage.removeItem('mine_src')
    }, 2000)
  }

  onMounted(() => {
    // 动态雾霾效果
    if (document.querySelector('.section__canvas--third')) {
      VANTA.FOG({
        el: "#canvas3",
        mouseControls: true,
        touchControls: true,
        gyroControls: false,
        minHeight: 200.00,
        minWidth: 200.00,
        highlightColor: 0xA034FA,
        midtoneColor: 0xA034FA,
        lowlightColor: 0xE66C12,
        baseColor: 0x16142A,
        blurFactor: 0.90,
        speed: 5.70,
        zoom: 1.00
      })
    }

  })

  const isSend = ref(false)
  const seconds = ref(60)
  const timer = ref(null)
  const sendEmail = () => {
    if (!formData.email) {
      ElMessage({
        duration: 1500,
        message: "Email cannot be empty",
        type: 'error',
        onClose: () => {}
      })
      return
    }

    isSend.value = true
    systemStore.emailCodeSendApi({email: formData.email, event: 'register'})
    timer.value = setInterval(() => {
      if (seconds.value <= 0) {
        clearInterval(timer.value)
        isSend.value = false
        seconds.value = 60
      }
      seconds.value--
    }, 1000)
  }

</script>

<template>
  <div>
    <!-- page wrap -->
    <div class="section section--content">
      <div class="section__content">
        <!-- form -->
        <form action="#" class="form form--content">
          <div class="form__logo-wrap">
            <a href="/" class="form__logo">
              <img :src="website.website_logo" alt="">
            </a>
<!--            <span class="form__tagline">Arbitrage trading <br>HTML Template</span>-->
            <span class="form__tagline text-[20px]">{{website.website_name}}</span>
          </div>

<!--          <div class="form__group">-->
<!--            <input type="text" class="form__input" placeholder="Name">-->
<!--          </div>-->

          <div class="form__group">
            <input type="text" class="form__input" placeholder="Email" v-model="formData.email">
          </div>

          <div class="form__group">
            <input type="password" class="form__input" placeholder="Login Password" v-model="formData.password">
          </div>

          <div class="form__group">
            <input type="text" class="form__input" placeholder="Invitation code" v-model="formData.inviter">
          </div>

          <div class="tw-w-full tw-flex tw-items-center tw-justify-between tw-mb-5" v-if="systemStore.getWebsite.email_switch == 1">
              <input type="text" class="form__input tw-mr-2" placeholder="Email verification code" v-model="formData.code">
              <el-button :disabled="isSend" class="!tw-inline-block !tw-bg-purple-600 !tw-border-purple-600 !tw-text-white !tw-h-full" @click="sendEmail">{{!isSend? 'Send': seconds + ' s'}}</el-button>
          </div>

<!--          <div class="form__group form__group&#45;&#45;checkbox">-->
<!--            <input id="remember" name="remember" type="checkbox">-->
<!--            <label for="remember">I agree to the <a href="privacy.html">Privacy Policy</a></label>-->
<!--          </div>-->

          <el-button :loading="submitLoading" class="section__btn tw-w-full justify-self-left" native-type="button" @click="signUpSubmit">Sign up</el-button>

<!--          <span class="form__delimiter">or</span>-->

<!--          <div class="form__social">-->
<!--            <a class="fb" href="#"><i class="ti ti-brand-facebook"></i></a>-->
<!--            <a class="tw" href="#"><i class="ti ti-brand-x"></i></a>-->
<!--            <a class="gl" href="#"><i class="ti ti-brand-google"></i></a>-->
<!--          </div>-->

          <span class="form__text form__text--center">
            Already have an account?
            <a href="Javascript:;" @click="router.push({path: '/Signin'})">Sign in!</a>
          </span>

          <!-- design elements -->
          <span class="block-icon tw-cursor-pointer" @click="router.push({path: '/'})" :class="systemStore.getBlockIconColor()">
					<i class="ti ti-logout"></i>
				</span>
          <span class="screw screw--big-tr"></span>
          <span class="screw screw--big-bl"></span>
          <span class="screw screw--big-br"></span>
        </form>
        <!-- end form -->
      </div>

      <!-- animation background -->
      <div class="section__canvas section__canvas--full section__canvas--third" id="canvas3"></div>
    </div>
    <!-- end page wrap -->
  </div>
</template>

<style scoped>

</style>
